import { render, staticRenderFns } from "./MobileProfileNav.vue?vue&type=template&id=2ed74f98"
import script from "./MobileProfileNav.vue?vue&type=script&lang=js"
export * from "./MobileProfileNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports